/* eslint-disable @typescript-eslint/no-unused-vars */
export type Order = 'asc' | 'desc';

function normalizeString(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  const aRaw = a[orderBy];
  const bRaw = b[orderBy];

  const aValue = typeof aRaw === 'string' ? normalizeString(aRaw) : aRaw;
  const bValue = typeof bRaw === 'string' ? normalizeString(bRaw) : bRaw;

  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;

  return 0;
}

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: any[],
  comparator: (a: T, b: T) => number,
): typeof array {
  const stabilizedThis = Array.isArray(array)
    ? array.map((el, index) => [el, index] as [T, number])
    : [];
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

export { descendingComparator, getComparator, stableSort };
